window.isMac = false;
window.isIpad = false;
window.isIphone = false;
window.isIOS = false;
window.isAndroid = false;
window.isMobile = false;
window.isMSIE = false;
window.isSafari = false;

if (window.navigator && window.navigator.userAgent) {
  const userAgent = window.navigator.userAgent;
  window.isMac = !!~userAgent.indexOf('Mac');
  window.isIpad = !!~userAgent.indexOf('iPad');
  window.isIphone = !!~userAgent.indexOf('iPhone');
  window.isIOS = window.isIpad || window.isIphone;
  window.isAndroid = !!~userAgent.indexOf('Android');
  window.isMobile = window.isIpad || window.isIphone || window.isAndroid;
  window.isMSIE = !!~userAgent.indexOf('MSIE');
  // eslint-disable-next-line no-extra-boolean-cast
  window.isSafari = !!~userAgent.indexOf('Safari') && !(!!~userAgent.indexOf('Chrome'));
}
